import { Button, Container, Icon, RubricTable, Stack, Text, styled } from 'shell/components';

const Tablet = ({ rubric, onClickBack, onClickEdit, onClickDownloadCSV, onClickDelete }) => {
    return (
        <Container device={'tablet'}>
            <RootStack spacing={5}>
                <Stack spacing={3}>
                    <CustomButton startIcon={<Icon kind={'arrowLeft'} />} variant={'borderless'} onClick={onClickBack}>
                        Back
                    </CustomButton>
                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                        <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                            {rubric.rubric.title}
                        </Text>
                        <Stack direction={'row'} spacing={4}>
                            <Button
                                startIcon={<Icon kind={'edit'} />}
                                variant={'tertiary'}
                                onClick={() => onClickEdit(rubric)}
                            >
                                Edit
                            </Button>
                            <Button
                                color={'neutral'}
                                startIcon={<Icon kind={'download'} />}
                                variant={'tertiary'}
                                onClick={() => onClickDownloadCSV(rubric)}
                            >
                                Download CSV
                            </Button>
                            <Button
                                color={'destructive'}
                                startIcon={<Icon kind={'delete'} />}
                                variant={'tertiary'}
                                onClick={() => onClickDelete(rubric)}
                            >
                                Delete
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
                <RubricTable isExpanded type={'view'} data={rubric.rubric.criteria} />
            </RootStack>
        </Container>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(5),
    };
});

const CustomButton = styled(Button)(() => {
    return {
        alignSelf: 'flex-start',
    };
});

export default Tablet;
